import { useState } from 'react';
import { useNavigate, useSearchParams, Link as RouterLink } from 'react-router';
import { Alert, Box, Button, Card, FormControl, FormLabel, Input, Link, Stack, Typography } from '@mui/joy';

import { APIBusinessResetPassword } from '../../api_business_auth';

export default function BusinessResetPasswordPage() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const token = params.get('token') || '';

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const submit = async () => {
        setError(null);
        if (!token) { setError('Ссылка недействительна'); return; }
        if (password.length < 8) { setError('Пароль не короче 8 символов'); return; }
        if (password !== confirm) { setError('Пароли не совпадают'); return; }
        setLoading(true);
        try {
            await APIBusinessResetPassword(token, password);
            navigate('/business/login');
        } catch (e) {
            setError(e?.response?.data?.error || 'Не удалось сменить пароль');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', px: 2 }}>
            <Card sx={{ p: 3, borderRadius: 'xl', boxShadow: 'lg', maxWidth: 420, width: '100%' }}>
                <Typography level="h4" sx={{ mb: 1.5 }}>Новый пароль</Typography>
                {!token && <Alert color="danger" sx={{ mb: 1.5 }}>
                    Ссылка недействительна. <Link component={RouterLink} to="/business/forgot-password">Запросить новую</Link>
                </Alert>}
                {error && <Alert color="danger" sx={{ mb: 1.5 }}>{error}</Alert>}
                <Stack spacing={1.5}>
                    <FormControl>
                        <FormLabel>Новый пароль</FormLabel>
                        <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Повторите пароль</FormLabel>
                        <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                               onKeyDown={(e) => e.key === 'Enter' && submit()} />
                    </FormControl>
                    <Button onClick={submit} loading={loading} disabled={!token}>Сменить пароль</Button>
                </Stack>
            </Card>
        </Box>
    );
}